import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/inventory/$')({
	loader: () => {
		throw redirect({ to: '/inventory/stock' })
	},
	component: RouteComponent,
})

function RouteComponent() {
	return null
}
